module.exports = __webpack_public_path__ + "static/feat-work-1-db8a51636fb09e27b30154196789672c.svg";